import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";

export async function GetDominUrl() {
  return fetch(
    Config.apiUrl +
      "UserCompany/GetDominUrl",
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetIPConfigurationDetails(IPAddress) {
  return fetch(
    Config.apiUrl +"IPConfiguration/GetIPConfigurationDetails?ipaddress="+ IPAddress,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
